<template>
    <div class="flex flex-col lg:flex-row mt-10">
        <nav class="border border-blue-light bg-blue-lightest lg:flex-shrink-0 rounded lg:self-start">
            <div class="border-b border-blue-light" :id="category.slug" :key="category.id" v-for="category in categories">
                <div class="cursor-pointer flex items-center justify-between p-4" @click.prevent="toggle(category)">
                    <span class="font-bold text-blue uppercase">{{ category.name }}</span>

                    <svg class="fill-current h-4 w-4 ml-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 18.59V3a1 1 0 0 1 2 0v15.59l5.3-5.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-7-7a1 1 0 0 1 1.4-1.42l5.3 5.3z" v-if="toggled(category)" />
                        <path d="M18.59 13H3a1 1 0 0 1 0-2h15.59l-5.3-5.3a1 1 0 1 1 1.42-1.4l7 7a1 1 0 0 1 0 1.4l-7 7a1 1 0 0 1-1.42-1.4l5.3-5.3z" v-else />
                    </svg>
                </div>

                <div class="bg-white border-t border-blue-light p-4" @click.prevent="select(service)" v-for="service in category.services" v-if="toggled(category)">
                    <h3 class="cursor-pointer flex items-center justify-between font-bold text-blue-dark text-sm">
                        <span>{{ service.name }}</span>
                        <svg class="fill-current h-4 w-4 ml-2 text-green" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" v-if="selected(service)">
                            <path d="M5.404 10.889l0.707 0.707-5.258 5.257-0.707-0.707 5.258-5.257zM17 6.222l-2.192 0.637-3.682 5.246 0.429 1.118-1.555 1.555-7.778-7.778 1.556-1.556 1.118 0.429 5.245-3.682 0.248-0.854 0.388-1.337 6.223 6.222zM15.098 5.734l-3.832-3.831-0.164 0.567-0.098 0.338-5.97 4.19-1.009-0.387-0.389 0.389 6.364 6.364 0.389-0.39-0.195-0.512-0.191-0.497 0.307-0.436 3.883-5.534 0.338-0.098 0.567-0.163z" />
                        </svg>
                    </h3>
                </div>
            </div>
        </nav>

        <div class="flex-1">
            <div :key="category.id" v-for="category in categories">
                <div class="mt-10 lg:ml-10 lg:mt-0" :key="service.id" v-for="service in category.services" v-if="selected(service)">
                    <h2 class="font-bold text-lg text-blue-darker">{{ service.name }}</h2>

                    <div class="markdown mt-5" v-html="service.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                category: {},
                service: {},
            };
        },

        props: {
            categories: {
                type: Array
            }
        },

        methods: {
            select(service) {
                this.service = service;

                this.$emit('change', service);
            },

            selected(service) {
                return this.service.id === service.id;
            },

            toggle(category) {
                this.category = this.toggled(category) ? {} : category;

                this.$forceUpdate();
            },

            toggled(category) {
                return this.category.id === category.id;
            },
        },

        mounted() {
            const hash = location.hash.slice(1);

            if (hash) {
                for (let category of this.categories) {
                    if (category.slug === hash) {
                        this.toggle(category);

                        break;
                    }
                }
            }

            if (!this.category.id) {
                this.toggle(this.categories[0]);
            }

            if (!this.service.id) {
                this.select(this.category.services[0]);
            }
        }
    };
</script>
